import { i18nTranslationHelper } from '@/i18n'
import { Trans } from 'react-i18next'

export interface TransI18nProps {
  i18nKey: string
  values?: { [key: string]: string }
  components?: { [key: string]: React.ReactElement }
}

const defaultComponents: { [key: string]: React.ReactElement } = {
  br: <br />,
  strong: <strong />,
  b: <b />,
  i: <i />,
  em: <em />,
  p: <p />,
  span: <span />,
  ul: <ul />,
  li: <li />,
  div: <div />,
  button: <button />
}

export function TransI18nValidations({ components, ...props }: TransI18nProps): React.ReactElement {
  return (
    <Trans
      t={i18nTranslationHelper.getTNamespace(i18nTranslationHelper.Prefix.VALIDATIONS)}
      components={{ ...defaultComponents, ...components }}
      {...props}
    />
  )
}

export function TransI18nInput({ components, ...props }: TransI18nProps): React.ReactElement {
  return (
    <Trans
      t={i18nTranslationHelper.getTNamespace(i18nTranslationHelper.Prefix.INPUT)}
      components={{ ...defaultComponents, ...components }}
      {...props}
    />
  )
}

export function TransI18nFields({ components, ...props }: TransI18nProps): React.ReactElement {
  return (
    <Trans
      t={i18nTranslationHelper.getTNamespace(i18nTranslationHelper.Prefix.FIELDS)}
      components={{ ...defaultComponents, ...components }}
      {...props}
    />
  )
}

export function TransI18nPages({ components, ...props }: TransI18nProps): React.ReactElement {
  return (
    <Trans
      t={i18nTranslationHelper.getTNamespace(i18nTranslationHelper.Prefix.PAGES)}
      components={{ ...defaultComponents, ...components }}
      {...props}
    />
  )
}

export function TransI18nComponents({ components, ...props }: TransI18nProps): React.ReactElement {
  return (
    <Trans
      t={i18nTranslationHelper.getTNamespace(i18nTranslationHelper.Prefix.COMPONENTS)}
      components={{ ...defaultComponents, ...components }}
      {...props}
    />
  )
}

export function TransI18nEntities({ components, ...props }: TransI18nProps): React.ReactElement {
  return (
    <Trans
      t={i18nTranslationHelper.getTNamespace(i18nTranslationHelper.Prefix.ENTITIES)}
      components={{ ...defaultComponents, ...components }}
      {...props}
    />
  )
}

export function TransI18nEnums({ components, ...props }: TransI18nProps): React.ReactElement {
  return (
    <Trans
      t={i18nTranslationHelper.getTNamespace(i18nTranslationHelper.Prefix.ENUMS)}
      components={{ ...defaultComponents, ...components }}
      {...props}
    />
  )
}
